import React from "react";
import { useNavigate } from "react-router-dom";
import "../components/ErrorPage.css";
import Logo from "/Logo.png";

interface ErrorPageProps {
  code?: number;
  title?: string;
  message?: string;
}

export default function ErrorPage({
  code = 404,
  title = "Page Not Found",
  message = "The page you're looking for doesn't exist or was moved.",
}: ErrorPageProps) {
  const navigate = useNavigate();

  return (
    <div className="error-container">
      <img src={Logo} alt="AI Squared Logo" className="error-logo" />

      <h1 className="error-code">{code}</h1>
      <h2 className="error-title">{title}</h2>
      <p className="error-message">{message}</p>

      <div className="error-buttons">
        <button className="error-btn" onClick={() => navigate("/")}>
          Go Home
        </button>

        <button className="error-btn secondary" onClick={() => navigate("/contact")}>
          Contact Support
        </button>
      </div>
    </div>
  );
}
